<template>
  <div>
    <div class="q_list">
      <ul>
        <li v-for="item in chioceQuestionData" :key="item.id">
          <div class="q_title">
            <div class="q_left">{{item.question}}</div>
            <div class="q_right">
              <div class="like">
                <div class="like_detail" @click="handleClick(item.id)">
                  <img :ref="item.id + 'img'" src="~assets/images/like01.png" alt="">
            
                </div>
                <span :ref="item.id">{{item.points}}</span>
              </div>
            </div>
          </div>
          <div class="q_name">
            <span>{{item.createDate | filterTime}}</span>
            <i>{{item.displayName}}</i>
          </div>
          <div class="repeat_part" v-if="item.ansSolutionVoList">
            <div style="border-bottom: .025rem solid #fff;padding:0 .2rem .1rem" v-for="(items,index) in item.ansSolutionVoList" :key="index">
              <div class="repeat_content">{{items.answer}}</div>
              <div class="repeat_name">
              【评论员】
              <span>{{items.operatorName}}</span> <span class="time">{{items.createDate |filterTimes}}</span>
            </div>
            
            </div>
            
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Utils from "assets/commonjs/tool";

import { getStore, setStore } from "assets/commonjs/storage";
import { toast } from "assets/commonjs/toast";
export default {
  data() {
    return {
      count: 1,
      companyId: 1,
      pc:false,
      like01:require("../assets/images/like01.png"),
      like02:require("../assets/images/like02.png"),
    };
  },
  props: ["chioceQuestionData"],
  filters: {
    filterTime(val) {
      if (!val) return "";
      let timeStamp = Utils.getDateTimeStamp(val);

      return Utils.getDateDiff(timeStamp);
    },
    filterTimes(val){
       if (!val) return "";
       val = val.substr(6)
       return val
    }
  },
  components: {
  
  },
  mounted() {
    this.clearIdStorage();
     if(!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){
      this.pc = true
    }
  },
  methods: {
    handleClick(id) {
      let clickedId = getStore("questionId_" + id);
      let status;
      if (clickedId == id) {
        //表示点击过
        status = 1;
        this.count = -1;
      } else {
        //未点击过
        status = 0;
        this.count = 1;
      }
      let data = {
        questionId: id,
        points: this.count,
        companyId: this.companyId
      };
      this.$api.strageList.questionLikes(data).then(res => {
        if (res.data && res.data.code == 0) {
          this.likeSucc(status, id);
        } else {
          toast(res.data.message);
        }
      });
    },
    likeSucc(status, id) {
      let activeEle = this.$refs[id][0];
      let activeImg = this.$refs[id +"img"][0];
      if (status == 0) {
        activeEle.innerHTML = Number(activeEle.innerHTML) + 1;
        activeImg.src = this.like02;
        setStore("questionId_" + id, id);
      } else if (status == 1) {
        activeEle.innerHTML = Number(activeEle.innerHTML) - 1;
        activeImg.src = this.like01
        setStore("questionId_" + id, "");
      }
    },
    clearIdStorage() {
      let keyArr = [];
      for (var i = 0; i < localStorage.length; i++) {
        keyArr.push(localStorage.key(i));
      }
      let idArr = keyArr.filter(item => item.startsWith("questionId_"));
      for (var j = 0; j < idArr.length; j++) {
        localStorage.removeItem(idArr[j]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.q_list {
  ul {
    li {
      padding-bottom: 0.4rem;
      border-bottom: 0.025rem solid #ddd;
      padding-top: 0.4rem;
      .q_title {
        display: flex;
        justify-content: space-between;
        .q_left {
          @include sc(0.28rem, #333);
          width: 6rem;
          text-align: justify;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        }
        .q_right {
          @include sc(0.24rem, #666);
          .like{
            display: flex
          };
          .like_detail{
            margin-right:.2rem; 
            img{
              width:.27rem;
            }
            }
        }
      }
      .q_name {
        font-size: 0.24rem;
        margin: 0.16rem 0 0;
        span {
          color: #666;
          margin-right: 0.2rem;
        }
        i {
          color: #e7a70c;
        }
      }
      .repeat_part {
        background: #f0f1f5;
        margin-top: 0.3rem;
        .repeat_name {
          @include sc(0.24rem, #0a95ff);
          margin-bottom: 0.1rem;
          .time{
            color: #666;
            margin-left:.2rem;
          }
        }
        .repeat_content {
          @include sc(0.28rem, #333);
          margin-top:0;
        }
      }
    }
  }
}
.like {
  position: relative;
  
}
</style>